/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode} from 'react';
import Drawer from '@material-ui/core/Drawer';
import Menu from '@material-ui/core/Menu';
import {makeStyles} from '@material-ui/core/styles';
import {GenericObject} from '@ion/core/src/types/entities';
import {Hidden} from '../../layout/Hidden';

export interface ResponsiveMenuType {
  children: ReactNode;
  open: boolean;
  anchorEl?: Element | ((element: Element) => Element);
  onClose?: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
  menuClasses?: GenericObject
  popoverClasses?: GenericObject
}

const useStyles = makeStyles(theme => ({
  menuList : {
    paddingBottom : '0px'
  }
}));

export const ResponsiveMenu = ({
  children,
  open,
  anchorEl,
  onClose,
  menuClasses = {},
  popoverClasses = {}
}: ResponsiveMenuType) => {
  const classes = useStyles();
  return (
    <>
      <Hidden show='desktop'>
        <Menu open={open}
          classes={{
            list : classes.menuList,
            ...menuClasses
          }}
          PopoverClasses={{...popoverClasses}}
          elevation={4}
          keepMounted
          anchorEl={anchorEl}
          onClose={onClose}>
          {children}
        </Menu>
      </Hidden>
      <Hidden show='mobile'>
        <Drawer anchor='bottom'
          open={open}
          onClose={onClose}
          ModalProps={{
            keepMounted : true
          }}
          classes={{...menuClasses}}>
          {children}
        </Drawer>
      </Hidden>
    </>
  );
};

export default ResponsiveMenu;
